import { loadScript } from '@paypal/paypal-js';

loadScript({
  'client-id': process.env.VUE_APP_PAYPAL_CLIENT_ID,
  'enable-funding': 'venmo',
  'disable-funding': 'card,paylater',
  commit: true
})
  .then(() => {
    // start to use the PayPal JS SDK script
  })
  .catch((err: unknown) => {
    console.error('failed to load the PayPal JS SDK script', err);
  });
